export default __webpack_public_path__ + "static/opening-ae19ade9b64fade9b2ac1aafa3f32373.mp4";